export type UmbUserKindType = 'Default' | 'Api';

export const UmbUserKind = Object.freeze({
	DEFAULT: 'Default',
	API: 'Api',
});
